import {createContext} from 'react';

const GraphExplorerContext = createContext();

export default GraphExplorerContext;
